/**
 * created by li si yi
 * 基础数据导入导出
 */
import React, {Component} from 'react'
import {message, Button, Pagination, Spin, Popconfirm} from 'antd';
import $ from 'jquery'
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";
import {Scrollbars} from "react-custom-scrollbars";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import UploadWall from "../../../components/upload/UploadWall";
import {JSON_TYPE_ORIGINAL} from "../../../constants";

class BaseDataImport extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            selectedRows: [],
            count: 0,
            params: {
                pageNum: 1,
                pageSize: 10,
            },
            tableName: '',
            selectedRowKeys:[],
            file: {}
        };
        this.exportData = this.exportData.bind(this);
    }

    uploadConfig = {
        name: 'file',
        action: '/cm-sites-sys/importBaseData',
        method: 'post',
        showUploadList: false,
        multiple: false,
        onChange: this.uploading.bind(this),
    };

    uploading(info) {
        if (info.file.status === 'uploading') {
            this.setState({
                loading: true
            })
        }
        if (info.file.status === 'done') {
            this.setState({
                loading: false,
            });
            message.success(`导出成功`);
        } else if (info.file.status === 'error') {
            this.setState({
                loading: false,
            });
            message.error(`导出失败！`);
        }
    }


    componentWillMount() {
        // getBaseDataInfos({}, this.callGetBaseDataInfos.bind(this));
    }

    componentDidMount() {
        this.getDataSource()
    }

    callGetBaseDataInfos(data) {
        this.setState({
            data: data
        })
    }

    columns = [
        {
            title: '表名称',
            dataIndex: 'tableName',
            ellipsis: true,
            width: 600,
            render: (text, record) => {
                return (
                    <div>{record ? record : ''}</div>
                )
            },
        },
        // {
        //     title: '类名称',
        //     dataIndex: 'className',
        //     render: (text) => {
        //         return (
        //             <div>{text ? text : ''}</div>
        //         )
        //     },
        // },
        // {
        //     title: '服务名称',
        //     dataIndex: 'serviceName',
        //     render: (text) => {
        //         return (
        //             <div>{text ? text : ''}</div>
        //         )
        //     },
        // },
        // {
        //     title: '表备注',
        //     dataIndex: 'comment',
        //     render: (text) => {
        //         return (
        //             <div>{text ? text : ''}</div>
        //         )
        //     },
        // },
    ];



    /**
     * 导出基础数据
     */
    exportData() {
        let data = this.state.selectedRows;
        if (!data || data.length == 0) {
            message.error('请选择要导出的表!');
            return;
        }
        let tablenames = [];
        for (let i = 0; i < data.length; i++) {
            tablenames.push(data[i].name);
        }
        let url = '/cm-sites-sys/data/export';
        this.exportBaseData(url);
    }

    // 导出建表脚本
    // exportMySqlDefine() {
    //     let data = this.state.selectedRows;
    //     if (!data || data.length == 0) {
    //         message.info('请选择要导出的表');
    //         return;
    //     }
    //     let tablenames = [];
    //     for (var i = 0; i < data.length; i++) {
    //         tablenames.push(data[i].name);
    //     }
    //     var url = "/cm-sites-sys/exportTableDefine?tablenames=" + tablenames;
    //     exportData(url);
    // }

    /**
     * 清除基础数据
     */
    clearBaseData(tableName) {
        let url = "/cm-sites-sys/data/wipe";
        window.loading.show();
        this.request({
            url: url,
            body: tableName,
            method: 'post',
            contentType: 'json',
            callBack: (res) => {
                if (res) {
                    this.setState({selectedRowKeys:[]});
                    message.success('表集合删除成功！');
                    this.getDataSource();
                }
                console.log(res)
            }
        })
        // 清除数据
    }

    render() {

        const {selectedRowKeys} = this.state;
       const rowSelection = {
           selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.state.selectedRows = selectedRows;
                this.state.tableName = selectedRows;
                this.state.selectedRowKeys = selectedRowKeys;
                this.setState({})
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        };
        const uploadConfig = this.uploadConfig;
        return <div
            style={{background: '#fff', maxHeight: 'calc(100vh - 100px)', borderRadius: 5, margin: '15px'}}>
            <Spin spinning={this.state.loading} tip="数据导入中...">
                <div style={{display: 'flex', padding: '24px 32px 0'}}>
                    <div className={"importButton"}>
                        <UploadWall
                            accept={'.' + [...JSON_TYPE_ORIGINAL].join(",.")}
                            multiple={false}
                            action="/storage/uploadFile"
                            listType={'list'}
                            // fileList={attach}
                            style={{padding: 'unset'}}
                            customRequest={new ChunkUpload({
                                checkFileURL: "/storage/checkFile",
                                checkChunkURL: "/storage/checkChunk",
                                uploadChunkURL: "/storage/uploadChunk",
                                chunkUploadOverURL: "/storage/chunkIsUploadOver",
                                mergeChunksURL: "/storage/mergeChunk"
                            }).start}
                            uploadBtnName={<Button type="primary">导入数据</Button>}
                            beforeUpload={this.beforeUpload}
                            onChange={this.uploadOnChange}
                            showPercent={false}
                        />
                    </div>
                    <div className={"importButton"}>
                        <Button type={'primary'} onClick={this.exportData}>导出数据</Button>
                    </div>
                    {/*<div className={"importButton"}>*/}
                    {/*    <Button onClick={this.exportMySqlDefine}>*/}
                    {/*        <Icon type="export"/> 导出建表脚本*/}
                    {/*    </Button>*/}
                    {/*</div>*/}
                    <div className={"importButton"}>
                        <Popconfirm
                            title="清空数据后不可恢复,确定要清空吗？"
                            onConfirm={() => {
                                if(this.state.selectedRowKeys.length){
                                    this.clearBaseData(this.state.tableName)
                                }else{
                                    message.error('请先选择一条数据')
                                }

                            }}
                            okText="确定"
                            cancelText="取消"
                        >
                            <Button type={'primary'}>清除数据</Button>
                        </Popconfirm>

                    </div>
                </div>
                <style>{`
                        .importButton{
                            margin-right:10px;
                            margin-bottom:10px
                        }
                `}</style>
                <div style={{clear: "both", padding: '0px 32px', maxHeight: 'calc(100vh - 100px - 81px -76px)'}}>
                    {/*<Divider/>*/}
                    <Scrollbars autoHide autoHeight autoHeightMax={'calc(100vh - 257px)'}>
                        <BaseTable rowKey="id" pagination={false}
                                   rowSelection={rowSelection} columns={this.columns}
                                   dataSource={this.state.dataSource}/>
                    </Scrollbars>
                </div>
            </Spin>
            {this.renderFooter()}
        </div>
    }

    // 分页
    renderFooter = () => {
        let {params, count} = this.state;
        // 获取当前tab参数
        let {pageNum, pageSize} = params;
        return (
            <div className={'pagination'}>
                <div style={{padding: "0 10px 0"}}>共{count}条数据</div>
                <Pagination
                    showSizeChanger
                    current={pageNum}
                    pageSize={pageSize}
                    total={count}
                    showQuickJumper={true}
                    onChange={(page, pageSize) => this.pageChange(page, pageSize)}
                    onShowSizeChange={(page, pageSize) => this.pageChange(page, pageSize)}
                />
            </div>
        )
    };

    //分页
    pageChange(page, pageSize) {
        // console.log(page, pageSize);
        let {params} = this.state;
        params.pageNum = page;
        params.pageSize = pageSize;
        this.state.selectedRows=[];
        this.state.selectedRowKeys= [];
        this.setState({},()=>{
            this.getDataSource();
        });

    };

    // 上传excel
    uploadOnChange = (info) => {
        // console.log(info.fileList[0]);
        if (info.file.status === 'done') {
            this.importFile(info.file);
        }
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if (info.file.response && info.file.response.data) {
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.md5 = info.file.response && info.file.response.md5;
                // item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        this.setState({
            fileList: info.fileList
        })
    };

    // 导入
    importFile(file) {
        console.log('file------------------', file);
        if (!file.response && !file.response.data && !file.response.data.md5) {
            return
        }
        // console.log(file.response);
        let params = {
            tableName: file.response && file.response.data && file.response.data.prefix ? file.response.data.prefix : file.response.prefix,
            md5: file.response && file.response.data && file.response.data.md5 ? file.response.data.md5 : file.response.md5,
        };
        this.request({
            url: '/cm-sites-sys/data/import',
            method: 'post',
            body: params,
            callBack: (res) => {
                if (res) {
                    message.success(('数据导入成功！'));
                    this.getDataSource();
                }
            }
        })
    };

    // 获取表格数据
    getDataSource() {
        this.request({
            url: '/cm-sites-sys/data/getPageList',
            method: 'post',
            body: this.state.params,
            callBack: (res) => {
                // console.log(res.data);
                let dataSource = [];
                let count = 0;
                if (res) {
                    dataSource = res.data;
                    count = res.count;
                    this.setState({dataSource, count})
                }
            }
        })
    };

    /**
     * 导出活动数据；
     * @param url
     */
    exportBaseData(url) {
        this.request({
            url: url,
            method: 'downloadPost',
            contentType: 'json',
            body: this.state.tableName,
        });
    }
}

export default BaseDataImport;